var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9806 6.84742C14.3948 5.40692 12.4149 4.38973 10.2208 3.97523V5.50872L10.2214 5.50886V15.7253C9.74438 15.8608 9.24923 15.9538 8.74044 15.9998V3.48376L7.2594 1.76237V15.9998C6.75075 15.9538 6.25575 15.8608 5.77882 15.7253V4.34462L5.77826 4.34495V3.97537C3.58463 4.38994 1.60506 5.40697 0.0195096 6.84718C0.589054 2.97403 3.9451 0 8.00002 0C12.055 0 15.4111 2.97415 15.9806 6.84742Z",
    fill: "#FFDF37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.04477C14.871 7.67307 13.3936 6.59694 11.7025 5.95062V15.1405C14.0032 13.9569 15.6574 11.7047 16 9.04477Z",
    fill: "#FFDF37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29778 15.1407V5.95044C2.60654 6.59671 1.12903 7.67281 0 9.04452C0.342579 11.7046 1.9969 13.957 4.29778 15.1407Z",
    fill: "#FFDF37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2236e71925495757129c7ecdf0bf8ac2.svg";
export { ForwardRef as ReactComponent };